module.exports = __webpack_public_path__ + "img/yuan2.516e3a97.png";